// src/pages/bonusHistory/hooks/useBonusHistoryScreen.ts
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getApi } from "../../api/api";
import { BonusStats } from "../../common/types/types";
import { selectIsOnline } from "../../store/slices/networkSlice";
import { selectBonusHistory } from "../../store/slices/bonusSlice";

export const useBonusHistoryScreen = () => {
  const transactions = useSelector(selectBonusHistory);
  const [stats, setStats] = useState<BonusStats | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const api = getApi();
  const isOnline = useSelector(selectIsOnline);

  const loadStats = useCallback(async () => {
    if (!isOnline) {
      setError("Нет подключения к интернету");
      return;
    }

    try {
      setLoading(true);
      const data = await api.getBonusStats();
      if (data) setStats(data);
      setError(null);
    } catch (err) {
      console.error("Error loading stats:", err);
      setError("Не удалось загрузить статистику");
    } finally {
      setLoading(false);
    }
  }, [isOnline, api]);

  useEffect(() => {
    if (isOnline) {
      loadStats();
    }
  }, [isOnline, loadStats]);

  const refresh = useCallback(async () => {
    setError(null);
    await loadStats();
  }, [loadStats]);

  return {
    transactions,
    stats,
    loading,
    error,
    isOnline,
    refresh,
  };
};
